export const SESSION_IDLE_TIME_KEY = 'sessionTimeoutIdleTime';
export const SESSION_PROMPT_TIMEOUT_KEY = 'sessionTimeoutPromptTime';

export const DEFAULT_IDLE_TIME_MS = 20 * 60 * 1000; // 20 mins
export const DEFAULT_PROMPT_TIMEOUT_SEC = 1 * 60; // 1 min in seconds

export const mapApiConfigToSessionValues = (payload) => ({
  idleTimeMs: Number(payload.IDLE_TIME),
  promptTimeoutSec: Number(payload.PROMPT_TIME) / 1000,
});

export const isValidSessionTimeoutConfig = ({ idleTimeMs, promptTimeoutSec }) =>
  Number.isFinite(idleTimeMs) &&
  Number.isFinite(promptTimeoutSec) &&
  idleTimeMs > 0 &&
  promptTimeoutSec > 0 &&
  promptTimeoutSec * 1000 < idleTimeMs;

export const getCachedSessionTimeoutConfig = () => {
  const idleTime = localStorage.getItem(SESSION_IDLE_TIME_KEY);

  const promptTimeout = localStorage.getItem(SESSION_PROMPT_TIMEOUT_KEY);

  if (!idleTime || !promptTimeout) {
    return null;
  }

  const config = {
    idleTimeMs: Number(idleTime),
    promptTimeoutSec: Number(promptTimeout) / 1000,
  };

  if (!isValidSessionTimeoutConfig(config)) {
    return null;
  }

  return config;
};

export const setCachedSessionTimeoutConfigFromApi = (payload) => {
  localStorage.setItem(SESSION_IDLE_TIME_KEY, String(payload.IDLE_TIME));

  localStorage.setItem(SESSION_PROMPT_TIMEOUT_KEY, String(payload.PROMPT_TIME));
};

export const clearSessionTimeoutConfigCache = () => {
  localStorage.removeItem(SESSION_IDLE_TIME_KEY);

  localStorage.removeItem(SESSION_PROMPT_TIMEOUT_KEY);
};

export const getDefaultSessionTimeoutConfig = () => ({
  idleTimeMs: DEFAULT_IDLE_TIME_MS,
  promptTimeoutSec: DEFAULT_PROMPT_TIMEOUT_SEC,
});

export const getInitialSessionTimeoutConfig = () => {
  const cached = getCachedSessionTimeoutConfig();

  if (cached) {
    return { ...cached, configReady: true };
  }

  return {
    idleTimeMs: DEFAULT_IDLE_TIME_MS,
    promptTimeoutSec: DEFAULT_PROMPT_TIMEOUT_SEC,
    configReady: false,
  };
};
